import { HttpErrorResponse } from '@angular/common/http';

export const PALLET_LAYER_CALCULATE_FAILED_API_MESSAGE =
  'No pallet layer could be calculated for the given specifications';

const PALLET_LAYER_OPERATION_URL_PATTERNS = [
  'project/group/layer/calculate',
  'project/group/layer/add',
  'project/group/pallet/fill',
];

export function isPalletLayerCalculateFailedError(error: unknown): boolean {
  if (error == null || typeof error !== 'object' || !('error' in error)) {
    return false;
  }
  return (error as HttpErrorResponse).error === PALLET_LAYER_CALCULATE_FAILED_API_MESSAGE;
}

export function isPalletLayerOperationRequest(url: string | null | undefined): boolean {
  if (!url) {
    return false;
  }
  return PALLET_LAYER_OPERATION_URL_PATTERNS.some((pattern) => url.includes(pattern));
}

/** True when the load cannot fit the active pallet / loading space for layer operations. */
export function shouldShowPalletLayerLoadTooLargeMessage(
  error: unknown,
  requestUrl?: string | null,
): boolean {
  if (isPalletLayerCalculateFailedError(error)) {
    return true;
  }
  if (!requestUrl) {
    return false;
  }
  // calculate/fill failures often mean the load does not fit. layer/add can fail for other
  // reasons (payload validation, missing layer id) — do not map those to this message.
  const isCalculateOrFill =
    requestUrl.includes('project/group/layer/calculate') ||
    requestUrl.includes('project/group/pallet/fill');
  if (!isCalculateOrFill) {
    return false;
  }
  const status = (error as HttpErrorResponse)?.status;
  return status === 400 || status === 500;
}
